import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";

const getStatusColor = (status) => {
  switch (status) {
    case "Scheduled":
      return {
        bgcolor: "#DBEAFE",
        color: "#1E40AF",
        border: "1px solid #1E40AF",
      };
    case "Pending":
      return {
        bgcolor: "#FEF3C7",
        color: "#D97706",
        border: "1px solid #D97706",
      };
    case "Completed":
      return {
        bgcolor: "#D1FAE5",
        color: "#059669",
        border: "1px solid #059669",
      };
    default:
      return {
        bgcolor: "#E5E7EB",
        color: "#374151",
        border: "1px solid #374151",
      };
  }
};

const WorkOrdersTable = ({ workOrders }) => {
  return (
    <>
      {/* Table */}
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "none",
          border: "1px solid #E5E7EB",
          overflowX: "auto",
        }}
      >
        <Table
          sx={{
            minWidth: { xs: 600, md: "auto" },
            borderCollapse: "separate",
            borderSpacing: 0,
          }}
        >
          <TableHead
            sx={{
              "& th": {
                borderBottom: "1px solid #E5E7EB",
              },
              "& th:last-child": {
                borderRight: "none",
              },
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#62748E",
                  py: { xs: 1.25, md: 1.5 },
                  px: { xs: 1.5, md: 2 },
                }}
              >
                Work Order
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#62748E",
                  py: { xs: 1.25, md: 1.5 },
                  px: { xs: 1.5, md: 2 },
                }}
              >
                Title
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#62748E",
                  py: { xs: 1.25, md: 1.5 },
                  px: { xs: 1.5, md: 2 },
                }}
              >
                Status
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#62748E",
                  py: { xs: 1.25, md: 1.5 },
                  px: { xs: 1.5, md: 2 },
                }}
              >
                Assigned To
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& td": {
                borderBottom: "1px solid #E5E7EB",
              },
              "& td:last-child": {
                borderRight: "none",
              },
            }}
          >
            {workOrders.map((order, index) => {
              const statusColors = getStatusColor(order.status);
              return (
                <TableRow
                  key={`${order.id}-${index}`}
                  sx={{
                    "&:last-child td": { border: 0 },
                    "&:hover": { bgcolor: "#F9FAFB" },
                  }}
                >
                  <TableCell
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "#020618",
                      py: { xs: 1.5, md: 2 },
                      px: { xs: 1.5, md: 2 },
                      whiteSpace: "nowrap",
                    }}
                  >
                    {order.id}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "#020618",
                      py: { xs: 1.5, md: 2 },
                      px: { xs: 1.5, md: 2 },
                      whiteSpace: "nowrap",
                    }}
                  >
                    {order.title}
                  </TableCell>
                  <TableCell
                    sx={{
                      py: { xs: 1.5, md: 2 },
                      px: { xs: 1.5, md: 2 },
                    }}
                  >
                    <Chip
                      label={order.status}
                      sx={{
                        ...statusColors,
                        fontWeight: 600,
                        fontSize: "12px",
                        height: "16px",
                        borderRadius: 0.75,
                        padding: "10px 4px",
                      }}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "#020618",
                      py: { xs: 1.5, md: 2 },
                      px: { xs: 1.5, md: 2 },
                      whiteSpace: "nowrap",
                    }}
                  >
                    {order.assignedTo}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default WorkOrdersTable;
